<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<!-- <em class="lt_text">Item ID</em>
				<span class="int_type sm_int">
					<input type="text" v-model.trim="item_id" placeholder="Enter Item ID" autofocus autocomplete="off" @keyup.enter="search()" />
				</span> -->
				<!-- <em class="lt_text">Name</em> -->
				<label for="active_only" class="mgr_15"> <input type="checkbox" id="active_only" v-model="active_only" />Active Only</label>
				<span class="int_type" style="width:520px;">
					<AC ref="ac" :source="selectACItems" @selected="selectACItem" results-display="code_name" placeholder="Item / Name or ID"> </AC>
				</span>
				<span class="mgr_5">
					<CustomDatePicker v-model="date_from" /> ~
					<CustomDatePicker v-model="date_to" />
				</span>
				<em class="lt_text">Reason</em>
				<span class="int_type_no_border mgr_10">
					<!-- <CodeSelect className="tbl_select" :codes="inventoryAdjustTypes" :showDesc="false" v-model="adjust_reason" /> -->
					<select class="tbl_select full_int" v-model="adjust_reason">
						<option :value="null">All</option>
						<option value="purchase">Purchase</option>
						<option value="sale">Sales</option>
						<option value="adjust">Adjust</option>
						<option value="repack">Repack</option>
						<option value="subdivide">Subdivision</option>
						<option value="sample">Sample</option>
						<option value="slip">Slip</option>
						<option v-if="use_shopify" value="shopify">Shopify</option>
					</select>
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<template v-if="user.company_id == 'jc'">
					<em class="lt_text">Item Code</em>
					<span class="int_type" style="width:120px;">
						<input type="text" v-model.trim="item_code" readonly autocomplete="off" />
					</span>
				</template>
				<template v-else>
					<em class="lt_text">{{ headers.class }} Code</em>
					<span class="int_type" style="width:140px;">
						<input type="text" v-model.trim="class_code" readonly autocomplete="off" />
					</span>
					<em class="lt_text">Color</em>
					<span class="int_type" style="width:100px;">
						<input type="text" v-model.trim="color_code" readonly autocomplete="off" />
					</span>
				</template>

				<em class="lt_text">Name</em>
				<span class="int_type" style="width:600px;">
					<input type="text" v-model.trim="item_name" readonly autocomplete="off" />
				</span>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<!-- <th style="width: 70px;">Item ID</th> -->
					<th style="width: 200px;">Item Code</th>
					<th>Item Name</th>
					<th style="width: 150px;">
						<a href="javascript:;" @click="sort('crt_dt')">Datetime{{ sortMark('crt_dt') }}</a>
					</th>
					<th style="width: 110px;">Operator ID</th>
					<th style="width: 110px;">
						<a href="javascript:;" @click="sort('operator_name')">Operator Name{{ sortMark('operator_name') }}</a>
					</th>
					<th style="width: 110px;">
						<a href="javascript:;" @click="sort('reason')">Reason{{ sortMark('reason') }}</a>
					</th>
					<th style="width: 85px;">
						<a href="javascript:;" @click="sort('sh_no')">SH No.{{ sortMark('sh_no') }}</a>
					</th>
					<th style="width: 110px;">S/O No.</th>
					<th style="width: 110px;">Inv. No.</th>
					<th style="width: 85px;">Ship To</th>
					<th style="width: 95px;">Sample No.</th>
					<th style="width: 95px;">Slip No.</th>
					<th style="width: 70px;">Before</th>
					<th style="width: 70px;">Change</th>
					<th style="width: 70px;">After</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="history in histories" v-bind:key="history.inventory_no">
					<!-- <td class="al_left">{{ history.item_id }}</td> -->
					<td class="al_left">{{ history.item_code }}</td>
					<td class="al_left truncate">{{ history.item_name }}</td>
					<td class="al_left">{{ history.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td class="al_left">{{ history.operator_id }}</td>
					<td class="al_left truncate">{{ history.operator_name }}</td>
					<td class="al_left">{{ history.adjust_reason }}</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoShipment(history.sh_no)">{{ history.sh_dn }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoSO(history.invoice_no)">{{ history.so_dn }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoInvoice(history.invoice_no)">{{ history.invoice_dn }}</a>
					</td>
					<td class="al_left">{{ history.ship_to_code }}</td>
					<td class="al_left">
						<a v-if="history.sample_no" href="javascript:;" @click="gotoSample(history.sample_no)">{{ history.sample_dn }}</a>
						<a v-if="history.sample_inout_no" href="javascript:;" @click="gotoSampleInout(history.sample_inout_no, history.crt_dt)">SAMPLE IN</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoSlip(history.slip_no)">{{ history.slip_dn }}</a>
					</td>
					<td class="al_right">{{ history.before_quantity | commaSeparated }}</td>
					<td class="al_right">{{ history.diff_quantity | commaSeparated }}</td>
					<td class="al_right">{{ history.after_quantity | commaSeparated }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li><a href="javascript:void(0);" v-on:click="excel">Excel</a></li>
				<li><a href="javascript:void(0);" v-on:click="print">Print</a></li>
				<li v-if="item_id"><router-link :to="{ name: 'inventoryDetail', params: {}, query: { backUri: this.uri, item_id: this.item_id } }">Detail</router-link></li>
			</ul>
		</div>
	</div>
</template>

<script>
//import { today, daysAgo } from '@/utils/date';
import { isDate, toDate, dateDiff, today } from '@/utils/date';
import moment from 'moment';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectItem } from '@/api/item/master.js';
import { apiSelectInventoryHistoryList } from '@/api/item/inventory.js';
import AC from '@/components/common/AC';
import { exportDataExcel, reportMrtUrl, reportRender } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,
			active_only: true,

			date_from: null,
			date_to: today(),
			item_id: null,
			item_name: null,
			item_code: null,
			class_code: null,
			color_code: null,
			adjust_reason: null,

			histories: [],

			modalName: '',
			showModal: false,

			sort_key: null,
			sort_direction: 'ASC',
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		use_shopify() {
			return this.profile.shopify === 'Y';
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		AC,
	},
	methods: {
		async getData() {
			const { data } = await apiSelectInventoryHistoryList({
				paging_yn: 'N',
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				item_id: this.item_id,
				date_from: this.date_from,
				date_to: this.date_to,
				adjust_reason: this.adjust_reason,
			});

			return data;
		},

		async print() {
			const data = await this.getData();

			data.date_from = this.date_from;
			data.date_to = this.date_to;
			data.by = this.user.user_id;

			await reportRender(data, 'InventoryHistory', reportMrtUrl('InventoryHistory'));
			//console.log(data);
		},
		async excel() {
			const data = await this.getData();

			//var vm = this;
			let histories_for_excel = data.inventoryHistoryList;
			histories_for_excel.forEach(h => {
				// h.class_code = vm.class_code;
				// h.color_code = vm.color_code;
				h.crt_dt_local = moment(h.crt_dt).format('MM-DD-YYYY HH:mm:ss');
				if (h.sample_no) h.sample_display_no = h.sample_dn;
				else if (h.sample_inout_no) h.sample_display_no = 'SAMPLE IN';
				else h.sample_display_no = null;
			});

			let fileName = 'InventoryHistory_' + this.class_code + '_' + this.color_code;
			if (this.date_from) fileName += '_' + this.date_from;
			if (this.date_to) fileName += '_' + this.date_to;

			let headers = [
				{ key: 'item_id', name: 'Item ID', width: 10, dataType: defaultDataType.string },
				{ key: 'class_code', name: 'Class', width: 17, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'crt_dt_local', name: 'Datetime', width: 20, dataType: defaultDataType.string },
				{ key: 'operator_id', name: 'Operator ID', width: 15, dataType: defaultDataType.string },
				{ key: 'operator_name', name: 'Operator Name', width: 18, dataType: defaultDataType.string },
				{ key: 'adjust_reason', name: 'Reason / Description', width: 20, dataType: defaultDataType.string },
				{ key: 'sh_dn', name: 'SH No', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice No', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_code', name: 'Ship To', width: 15, dataType: defaultDataType.string },
				{ key: 'sample_display_no', name: 'Sample No', width: 15, dataType: defaultDataType.string },
				{ key: 'slip_dn', name: 'Slip No', width: 15, dataType: defaultDataType.string },
				{ key: 'before_quantity', name: 'Before', width: 10, dataType: defaultDataType.currency },
				{ key: 'diff_quantity', name: 'Change', width: 10, dataType: defaultDataType.currency },
				{ key: 'after_quantity', name: 'After', width: 10, dataType: defaultDataType.currency },
			];

			exportDataExcel(histories_for_excel, headers, fileName);
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectInventoryHistories();
			//console.log(sort_key);
		},
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=' + this.active_only + '&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			//console.log(i.selectedObject);
			this.item_id = i.selectedObject.item_id;
			this.search();
			//this.$refs.ac.clear();

			//if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			//else this.item_classes_string = c.selectedObject.code;

			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},
		gotoShipment(sh_no) {
			//this.$router.push({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, sh_no: sh_no } });
			let routeData = this.$router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sh_no: sh_no } });
			window.open(routeData.href, 'herp_shipment');
		},
		gotoInvoice(invoice_no) {
			//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice_no } });
			let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice_no } });
			window.open(routeData.href, 'herp_invoice');
		},
		gotoSO(invoice_no) {
			//this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, invoice_no: invoice_no } });
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice_no } });
			window.open(routeData.href, 'herp_so');
		},
		gotoSample(sample_no) {
			let routeData = this.$router.resolve({ name: 'sampleDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sample_no: sample_no } });
			window.open(routeData.href, 'herp_sample');
		},
		gotoSampleInout(sample_inout_no, crt_dt) {
			let routeData = this.$router.resolve({ name: 'sampleInout', path: '/sales/sample/inout', query: { inout_date: this.$moment(crt_dt).format('MM-DD-YYYY'), sample_inout_no: sample_inout_no } });
			window.open(routeData.href, 'herp_sample_inout');
		},
		gotoSlip(slip_no) {
			let routeData = this.$router.resolve({ name: 'slipDetail', params: { mode: 'detail' }, query: { backUri: this.uri, slip_no: slip_no } });
			window.open(routeData.href, 'herp_slip');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInventoryHistories(pageNo);
		},
		reset() {
			this.item_id = null;
			this.item_name = null;
			this.color_code = null;
			this.class_code = null;

			this.date_from = null;
			this.date_to = today();
			this.adjust_reason = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		search() {
			this.selectInventoryHistories();
		},
		async selectInventoryHistories(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			if (!this.item_id && (!this.date_from || !this.date_to || !isDate(this.date_from) || !isDate(this.date_to))) {
				this.$toast.error('Invalid search date without item');
				return;
			}

			if (!this.item_id) {
				var date_from = toDate(this.date_from);
				var date_to = toDate(this.date_to);
				//console.log(date_from, date_to, 'hmmm:', dateDiff(date_from, date_to));
				if (dateDiff(date_from, date_to) > 30) {
					this.$toast.error('Maximum search period without item is 30 days');
					return;
				}
			}

			if (this.item_id && !this.selectItem()) return;

			const { data } = await apiSelectInventoryHistoryList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				item_id: this.item_id,
				date_from: this.date_from,
				date_to: this.date_to,
				adjust_reason: this.adjust_reason,
			});

			//console.log(data);

			this.histories = data.inventoryHistoryList;
			//console.log(this.histories);
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/item/inventory_history?item_id=' + this.item_id;
			if (this.date_from) uri += '&date_from=' + this.date_from;
			if (this.date_to) uri += '&date_to=' + this.date_to;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			//window.history.pushState({}, null, uri);
			//console.log(uri);
		},
		async selectItem() {
			const { data } = await apiSelectItem({
				item_id: this.item_id,
			});
			//console.log(data);
			if (data.item) {
				this.item_name = data.item.name;
				this.item_code = data.item.item_code;
				this.class_code = data.item.class_code;
				this.color_code = data.item.color_code;
				return true;
			}

			this.$toast.error('Item Not Found');
			return false;
		},
		gotoPartner(code) {
			//console.log(code);
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			window.open(routeData.href, 'herp_partner');
		},
		async index() {
			//const { data } = await apiIndex();
			//this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
		},
		async init() {
			//await this.index();
			if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.date_from) this.date_from = this.$route.query.date_from;
			if (this.$route.query.date_to) this.date_to = this.$route.query.date_to;

			if (this.item_id) await this.selectInventoryHistories(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_history');
		this.$store.commit('setSubTitle', 'Item -> Inventory History');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
